<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> </template>

    <div class="container-fluid" style="text-align: left">
      <div class="row mt-3">
        <div class="col-sm-3">
          <admin-nav></admin-nav>
        </div>

        <div class="col-sm-9">
          <h4>Contest Edit</h4>
          <br />

          <div class="col-12">
            <div class="col-6">
              <div class="form-group">
                <label for="exampleInputEmail1">Name</label>
                <input
                  type="text"
                  v-model="contest.name"
                  class="form-control"
                />
              </div>

              <div class="form-group">
                <label>District</label>
                <v-select
                  label="name"
                  :options="districts"
                  @search="districtSearch"
                  v-model="district_id"
                  :clearable="false"
                  :reduce="(d) => d.id"
                ></v-select>
              </div>

              <div class="form-group">
                <label>Program</label>
                <v-select
                  label="name"
                  :options="programs"
                  @search="programSearch"
                  v-model="contest.program_id"
                  :clearable="false"
                  :reduce="(p) => p.id"
                ></v-select>
              </div>
            </div>

            <hr />

            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-3">
                  <div class="d-flex flex-row align-items-end form-group">
                    <div class="flex-grow mr-3">
                      <label>Students</label>
                      <v-select
                        :getOptionLabel="userLabel"
                        :options="students"
                        @search="studentSearch"
                        v-model="selectedStudent"
                        :clearable="true"
                      >
                      </v-select>
                    </div>
                    <div>
                      <button
                        class="btn btn-primary"
                        @click="addStudent"
                        :disabled="
                          !selectedStudent ||
                          contest.student_ids.includes(selectedStudent.id)
                        "
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <ul>
                    <li
                      v-for="student in contest.students"
                      :key="student.id"
                      class="d-flex flex-row"
                    >
                      <div class="flex-grow">
                        {{ student.name.first }} {{ student.name.last }}
                      </div>
                      <button
                        class="btn btn-no-border btn-si-orange btn-si-icon"
                        @click="removeStudent(student)"
                        v-tippy
                        title="Remove"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-3">
                  <div class="d-flex flex-row align-items-end form-group">
                    <div class="flex-grow mr-3">
                      <label>Teachers</label>
                      <v-select
                        :getOptionLabel="userLabel"
                        :options="teachers"
                        @search="teacherSearch"
                        v-model="selectedTeacher"
                        :clearable="true"
                      >
                      </v-select>
                    </div>
                    <div>
                      <button
                        class="btn btn-primary"
                        @click="addTeacher"
                        :disabled="
                          !selectedTeacher ||
                          contest.teacher_ids.includes(selectedTeacher.id)
                        "
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <ul>
                    <li
                      v-for="teacher in contest.teachers"
                      :key="teacher.id"
                      class="d-flex flex-row"
                    >
                      <div class="flex-grow">
                        {{ teacher.name.first }} {{ teacher.name.last }}
                      </div>
                      <button
                        class="btn btn-no-border btn-si-orange btn-si-icon"
                        @click="removeTeacher(teacher)"
                        v-tippy
                        title="Remove"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-3">
                  <div class="d-flex flex-row align-items-end form-group">
                    <div class="flex-grow mr-3">
                      <label>Judges</label>
                      <v-select
                        :getOptionLabel="userLabel"
                        :options="judges"
                        @search="judgeSearch"
                        v-model="selectedJudge"
                        :clearable="true"
                      >
                      </v-select>
                    </div>
                    <div>
                      <br />
                      <button
                        class="btn btn-primary"
                        @click="addJudge"
                        :disabled="
                          !selectedJudge ||
                          contest.judge_ids.includes(selectedJudge.id)
                        "
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <ul>
                    <li
                      v-for="judge in contest.judges"
                      :key="judge.id"
                      class="d-flex flex-row"
                    >
                      <div class="flex-grow">
                        {{ judge.name.first }} {{ judge.name.last }}
                      </div>
                      <button
                        class="btn btn-no-border btn-si-orange btn-si-icon"
                        @click="removeJudge(judge)"
                        v-tippy
                        title="Remove"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-8">
                <a href="/#/contests" class="btn float-right">Cancel</a>
                <button @click="save" class="btn btn-primary float-right">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import AdminService from "@/services/AdminService";
import ProgramService from "@/services/ProgramService";
//import ContestService from "@/services/ContestService";
import _ from "lodash";

export default {
  name: "ContestEdit",

  props: ["user"],

  components: { MainPage, AdminNav },

  data() {
    return {
      id: this.$route.params.id,
      service: AdminService,
      contest: { district_id: null },
      districts: [],
      district_id: null,
      programs: [],
      program_id: null,

      students: [],
      selectedStudent: null,
      teachers: [],
      selectedTeacher: null,
      judges: [],
      selectedJudge: null,
    };
  },

  created() {
    AdminService.listDistricts({}).then((resp) => {
      this.districts = resp.data.result;
      if (this.id == "new") {
        this.contest = {
          name: "",
          is_contest: true,
          district_id: null,
          student_ids: [],
          teacher_ids: [],
          partner_ids: [],
          judge_ids: [],
          students: [],
          teachers: [],
          partners: [],
          judges: [],
        };
        return;
      }
      this.service
        .getSection(this.id)
        .then((resp) => {
          this.contest = resp.data;
          console.log(this.contest);
          this.district_id = this.contest.district_id;
        })
        .catch((err) => {
          alert(err);
        });
    });
  },

  watch: {
    district_id() {
      //prefill users
      if (this.id == "new" || this.district_id != this.contest.district_id) {
        AdminService.listUsers({}, "STUDENT", this.district_id).then((resp) => {
          this.contest.students = [];
          this.contest.student_ids = [];
          for (var s of resp.data.result) {
            this.contest.students.push(s);
            this.contest.student_ids.push(s.id);
          }
        });
        AdminService.listUsers({}, "TEACHER", this.district_id).then((resp) => {
          this.contest.teachers = [];
          this.contest.teacher_ids = [];
          for (var s of resp.data.result) {
            this.contest.teachers.push(s);
            this.contest.teacher_ids.push(s.id);
          }
        });
        AdminService.listUsers({}, "JUDGE", this.district_id).then((resp) => {
          this.contest.judges = [];
          this.contest.judge_ids = [];
          for (var s of resp.data.result) {
            this.contest.judges.push(s);
            this.contest.judge_ids.push(s.id);
          }
        });
      }
      
      //get dropdown values for remaining fields
      this.programSearch();
      this.studentSearch();
      this.teacherSearch();
      this.judgeSearch();
    },
  },

  methods: {
    save() {
      this.contest.district_id = this.district_id;
      console.log(this.contest);
      AdminService.saveSection(this.contest)
        .then(() => {
          window.location.href = "/#/contests";
        })
        .catch((err) => {
          alert(err);
        });
    },
    districtSearch(search) {
      if (!search) {
        search = "";
      }
      AdminService.listDistricts({ filter: search }).then((resp) => {
        this.districts = resp.data.result;
      });
    },
    programSearch(search, loading) {
      console.log(search, loading);
      ProgramService.getDistrictPrograms(this.district_id).then((resp) => {
        this.programs = resp.data;
      });
    },

    userLabel(user) {
      return user.name.first + " " + user.name.last;
    },

    studentSearch(search) {
      console.log(search);
      AdminService.listUsers(
        {
          filter: search,
        },
        "STUDENT",
        this.district_id
      ).then((resp) => {
        this.students = resp.data.result;
      });
    },
    addStudent() {
      if (this.selectedStudent) {
        this.contest.student_ids.push(this.selectedStudent.id);
        if (!this.contest.students) {
          this.contest.students = [];
        }
        this.contest.students.push(this.selectedStudent);
      } else {
        alert("Please select a student");
      }
      this.selectedStudent = null;
    },
    removeStudent(student) {
      this.contest.students = _.without(this.contest.students, student);
      this.contest.student_ids = _.without(
        this.contest.student_ids,
        student.id
      );
    },

    teacherSearch(search) {
      AdminService.listUsers(
        {
          filter: search,
        },
        "TEACHER",
        this.district_id
      ).then((resp) => {
        this.teachers = resp.data.result;
      });
    },
    addTeacher() {
      if (this.selectedTeacher) {
        this.contest.teacher_ids.push(this.selectedTeacher.id);
        if (!this.contest.teachers) {
          this.contest.teachers = [];
        }
        this.contest.teachers.push(this.selectedTeacher);
      } else {
        alert("Please select a teacher");
      }
      this.selectedTeacher = null;
    },
    removeTeacher(teacher) {
      this.contest.teachers = _.without(this.contest.teachers, teacher);
      this.contest.teacher_ids = _.without(
        this.contest.teacher_ids,
        teacher.id
      );
    },

    judgeSearch(search) {
      AdminService.listUsers(
        {
          filter: search,
        },
        "JUDGE",
        this.district_id
      ).then((resp) => {
        this.judges = resp.data.result;
      });
    },
    addJudge() {
      if (this.selectedJudge) {
        this.contest.judge_ids.push(this.selectedJudge.id);
        if (!this.contest.judges) {
          this.contest.judges = [];
        }
        this.contest.judges.push(this.selectedJudge);
      } else {
        alert("Please select a judge");
      }
      this.selectedJudge = null;
    },
    removeJudge(judge) {
      this.contest.judges = _.without(this.contest.judges, judge);
      this.contest.judge_ids = _.without(this.contest.judge_ids, judge.id);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
